import {APPROVAL_MENU_ITEMS} from './constants';

export function userHasAccessRights(userRoles, location) {
    let currentLocation = location ? location.pathname : document.location.pathname;

    let matchingMenuItem = {};

    APPROVAL_MENU_ITEMS.forEach((menuItem) => {
        if (menuItem.url === currentLocation) {
            matchingMenuItem = menuItem;
        } else if (menuItem.children) {
            menuItem.children.forEach((childMenuItem) => {
                if (menuItem.url + childMenuItem.url === currentLocation) {
                    matchingMenuItem = childMenuItem;
                }
            });
        }
    });

    return userRoles[matchingMenuItem.rightsToView];
}

export function canViewConfiguration(userRoles) {
    return userRoles.systemViewer || userRoles.systemAdministrator;
}

// Mirrors the legacy Menu visibility rule: hide /settings for users who are
// system-viewer only (i.e. not also admin or approver).
export function isSettingsVisible(userRoles) {
    const isOnlySystemViewer =
        userRoles?.systemViewer && !userRoles?.systemAdministrator && !userRoles?.approver;
    return !isOnlySystemViewer;
}